import { createSlugByIdNamePractice } from "../../../../../utils/globalUtilities";

export const QuickInfo = ({ info }: any) => {
  const onClickPreview = (item:any) => {
  let url = window.location.origin + '/';
   url  = url + 'research/preview-document?categoryName=null&fileId=' + item.mid + '&subCategory=null&category=' + createSlugByIdNamePractice(info.searchedData.categoryName)+'&platform=premium' ;
    window.open(url, '_blank');
  }

  return (
    <>
      {
        info?.allInfo?.quickinfo?.length ?
          <div className="info-list-1 quick-info-1">
            <div className="info-list-head">
              {" "}
              <h2 className="info-list-h2"> Quick Info </h2>{" "}
            </div>
            <ul className="info-items-1">
            {

          info?.allInfo?.quickinfo.map(
                (item: any, index: number) => (
                  
                    <li  key={`QuickInfo${index}`}>
                      <span className="li-span-left">
                        {" "}
                        {item.key}{" "}
                      </span>
                      <span className="li-span-right">
                        <ul>
                          {
                            item.value.map(
                              (information: any, indexinfo: number) => (
                                <li key={`QuickInfoData${indexinfo}`} onClick={()=> onClickPreview(information)} >
                                  {" "}
                                  <a className="cursor-pointer">
                                    {" "}
                                    {information.value}{" "}
                                  </a>{" "}
                                </li>
                              )
                            )
                          }
                        </ul>
                      </span>
                    </li>
                 
                )
              )

            }
 </ul>
          </div>
          : ''
      }
    </>
  )
}

export default QuickInfo


